import { Component, Input, OnInit } from '@angular/core';
import IZoningCodeRecord = ZoningAPI.IZoningCodeRecord;
import ISolrGroupIdsDataStatistic = ZoningAPI.ISolrGroupIdsDataStatistic;
import * as _ from 'lodash';

export interface ISolrGroupIdsDataStatisticExtended extends ISolrGroupIdsDataStatistic {
    zcvId: number;
}

const DEFAULT_ZCV_AU_STATISTIC: ISolrGroupIdsDataStatisticExtended = {
    addGroupIdsProcessed: 0,
    buildingsProcessed: 0,
    usesHashesAdded: 0,
    removeGroupIdsProcessed: 0,
    zcvId: null
};

@Component({
    standalone: false,
    selector: 'app-zoning-code-versions-au-statistic',
    templateUrl: './zoning-code-versions-au-statistic.component.html',
    styleUrls: ['./zoning-code-versions-au-statistic.component.scss', '../../../../shared/styles/mdl-table.scss']
})
export class ZoningCodeVersionsAuStatisticComponent implements OnInit {
    @Input()
    zoningCodeRecord: IZoningCodeRecord;

    _solrGroupIdsStatistic: ISolrGroupIdsDataStatisticExtended[];

    constructor() {}

    get solrGroupIdsStatistic(): ISolrGroupIdsDataStatisticExtended[] {
        if (!this.zoningCodeRecord) {
            return;
        }
        if (!this._solrGroupIdsStatistic) {
            this._solrGroupIdsStatistic = this.getStatisticArray();
        }
        return this._solrGroupIdsStatistic;
    }

    getStatisticArray(): ISolrGroupIdsDataStatisticExtended[] {
        if (!this.zoningCodeRecord) {
            return null;
        }
        const solrGroupIdsStatistic = _.get(this.zoningCodeRecord, 'MetaData.solrGroupIdsStatistic');
        if (!solrGroupIdsStatistic || !_.keys(solrGroupIdsStatistic).length) {
            return [DEFAULT_ZCV_AU_STATISTIC];
        }
        const result = [];
        _.forOwn(solrGroupIdsStatistic, (stat, zcvId) => {
            result.push({ ...stat, zcvId });
        });
        return _.sortBy(result, ['isLatest', 'zcvId']);
    }

    ngOnInit(): void {}
}
